import React from 'react';
import { useNavigate } from 'react-router-dom';
import { contextHref } from '../utils/collab';

/**
 * A shared view, a shared row, or a shared report, rendered inside a chat thread.
 *
 * ⚠️ Critical Note #71 — a shared view is a SIGNPOST, and it grants nothing. Everything
 * shown here comes from the server's `_resolve_context()`, which re-reads the panel under
 * THIS reader's privacy scope. When `visible` is false there is no title to show and no
 * link to follow, and the card says so plainly rather than rendering a dead one.
 */

// A card that names no panel — a BOM row or a BOM view — still has to say WHERE it points.
// Without this such a card read "Untitled", which is the one thing it is not.
const MODULE_LABELS = { trace: 'Traceability', training: 'Training', bom: 'BOM Viewer' };

const KINDS = {
  view: { label: 'Shared a view', tone: 'view' },
  row: { label: 'About a row', tone: 'row' },
  report: { label: 'Instant report', tone: 'report' },
  export: { label: 'Shared an export', tone: 'view' },
};

function ContextCard({ context, onNavigate }) {
  const navigate = useNavigate();
  if (!context) return null;

  const kind = KINDS[context.kind] || KINDS.view;

  if (context.visible === false) {
    return (
      <div className="collab-card collab-card--denied">
        <div className="collab-card-kind">Not available to you</div>
        <div className="collab-card-note">
          That panel is private, or it is not part of a module your account has.
        </div>
      </div>
    );
  }

  const focusKey = context.focus?.key || '';
  const href = contextHref(context);

  const go = () => {
    if (!href) return;
    if (onNavigate) onNavigate();
    navigate(href);
  };

  return (
    <div className={`collab-card collab-card--${kind.tone}`}>
      <div className="collab-card-kind">{kind.label}</div>
      <div className="collab-card-title">
        {focusKey || context.panel_title || MODULE_LABELS[context.module] || 'Untitled'}
      </div>
      {focusKey && (context.panel_title || MODULE_LABELS[context.module]) && (
        <div className="collab-card-sub">
          {context.panel_title || MODULE_LABELS[context.module]}
        </div>
      )}
      {context.label && <div className="collab-card-label">{context.label}</div>}
      {href && (
        <button type="button" className="collab-card-go" onClick={go}>
          {focusKey ? 'Jump to this row' : 'Open this view'} →
        </button>
      )}
    </div>
  );
}

export default ContextCard;
